// Show password
let showPwd = false;
window.switchPwd = (() => {
  showPwd = !showPwd;
  if (showPwd) {
    $('#show-password').find('i').addClass('fa-eye-slash').removeClass('fa-eye');
    $('input[name=password]').attr('type', 'text');
    $('input[name=password_confirmation]').attr('type', 'text');
  } else {
    $('#show-password').find('i').addClass('fa-eye').removeClass('fa-eye-slash');
    $('input[name=password]').attr('type', 'password');
    $('input[name=password_confirmation]').attr('type', 'password');
  }
});